import React from "react";
import "./LegalPrivacyPage.css";

const LegalPrivacyPage = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:info@swasthmitra.com";
  };

  const handleCallClick = () => {
    window.location.href = "tel:+917007512120";
  };

  return (
    <>
      <div className="legalPrivacySection">
        <h2>Legal Disclaimer and Privacy Policy</h2>
        <div className="legalPrivacyContent">
          <p className="effectiveDate"><strong>Effective Date:</strong> [Insert Date]</p>
          
          <p>
            By accessing or using this website (<a href="http://www.swasthmitra.com">www.swasthmitra.com</a>), you agree to be bound by the terms and conditions set forth herein. This Legal Disclaimer and Privacy Policy governs your use of the website and any services offered by <strong>SwasthMitra Healthcare Private Limited</strong> ("Company", "we", "us", "our").
          </p>
          
          <p>
            If you do not agree with any part of this Policy, please discontinue use of the website immediately.
          </p>

          <hr />

          <h3>🔹 1. Medical Disclaimer</h3>
          <ul>
            <li>The content and products available on this website, including medicines, supplements, and health-related accessories, are provided for <strong>general informational purposes only</strong>.</li>
            <li><strong>We do not offer medical advice, diagnosis, or treatment.</strong> All information should be used only in consultation with a registered medical practitioner.</li>
            <li>Any decision to purchase and consume products listed on this website must be made at your sole discretion, based on professional medical consultation.</li>
            <li>SwasthMitra is not liable for <strong>any adverse reactions or side effects</strong> arising from the use of any products sold through this website.</li>
          </ul>

          <h3>🔹 2. Prescription Requirements</h3>
          <ul>
            <li>Certain products, including but not limited to Schedule H and X drugs, may be sold <strong>only against a valid prescription</strong> issued by a licensed medical practitioner.</li>
            <li>Customers are responsible for ensuring that prescriptions uploaded are <strong>authentic, valid, and issued in their name</strong>.</li>
            <li>We reserve the right to reject any order that does not comply with applicable medical or legal requirements.</li>
          </ul>

          <h3>🔹 3. User Responsibility</h3>
          <ul>
            <li>Users shall not misuse, abuse, or attempt unauthorized access to this website or any data contained within it.</li>
            <li>You agree not to use this platform for fraudulent activities, impersonation, or misrepresentation.</li>
            <li>The user assumes <strong>full responsibility</strong> for the use of products purchased through this website.</li>
          </ul>

          <h3>🔹 4. Limitation of Liability</h3>
          <ul>
            <li>To the fullest extent permitted by applicable law, SwasthMitra shall not be held liable for <strong>any direct, indirect, incidental, special, or consequential damages</strong> arising out of or in connection with the use of this website or any product or service purchased through it.</li>
            <li>This includes, but is not limited to, <strong>loss of profits, data, health, or goodwill</strong>.</li>
          </ul>

          <h3>🔹 5. Intellectual Property Rights</h3>
          <ul>
            <li>All content available on this website — including but not limited to text, logos, graphics, product images, software, and layout — is the <strong>intellectual property of SwasthMitra</strong> or its content suppliers.</li>
            <li>Unauthorized copying, distribution, reproduction, or modification of any part of the website is strictly prohibited and may result in legal action.</li>
          </ul>

          <h3>🔹 6. Privacy Policy</h3>
          <p>We are committed to protecting your personal information and privacy.</p>
          
          <h4>What We Collect:</h4>
          <ul>
            <li>Name, contact number, address, email ID</li>
            <li>Health-related information (such as prescriptions)</li>
            <li>Payment and transactional information</li>
          </ul>
          
          <h4>How We Use It:</h4>
          <ul>
            <li>To fulfill your orders and provide services</li>
            <li>For customer support and service communication</li>
            <li>To improve our offerings and prevent fraud</li>
          </ul>
          
          <h4>Data Security:</h4>
          <p>We use industry-standard encryption and secure storage to protect your data. Access to user information is strictly restricted to authorized personnel only.</p>
          
          <h4>Sharing of Information:</h4>
          <ul>
            <li>We do <strong>not sell or rent</strong> your personal information to third parties.</li>
            <li>Data may be shared with service providers (logistics, payment gateways, etc.) <strong>only for order fulfillment purposes</strong>.</li>
            <li>We may disclose data if required by law, regulation, or court order.</li>
          </ul>

          <h3>🔹 7. Cookies & Tracking</h3>
          <ul>
            <li>Our website may use cookies or similar technologies to enhance user experience, track performance, and personalize content.</li>
            <li>By using our website, you consent to our use of cookies.</li>
          </ul>

          <h3>🔹 8. Modifications to the Policy</h3>
          <p>SwasthMitra reserves the right to modify, update, or change this policy at any time without prior notice. It is your responsibility to review this page periodically. Continued use of the website constitutes your agreement to any changes.</p>

          <h3>🔹 9. Governing Law & Jurisdiction</h3>
          <p>This agreement shall be governed by and construed in accordance with the laws of <strong>India</strong>. Any disputes arising under or in connection with the use of this website or the interpretation of this policy shall be subject to the <strong>exclusive jurisdiction of the courts of [Insert City, e.g., Mumbai, Delhi, etc.]</strong>, India.</p>

          <hr />

          <div className="contactSection">
            <h3>🔐 Contact Us</h3>
            <p>For any concerns, queries, or requests regarding this Legal & Privacy Policy, please write to:</p>
            <p>Email: <button className="contactButton" onClick={handleEmailClick}>info@swasthmitra.com</button></p>
            <p>Phone: <button className="contactButton" onClick={handleCallClick}>+91-7007512120</button></p>
          </div>

          <hr />

          <div className="finalNote">
            <h3>📌 Final Note</h3>
            <p>Use of this website implies acceptance of all terms outlined in this Legal Disclaimer and Privacy Policy.</p>
          </div>

          <div className="optionalSafeguards">
            <h3>🛡 Optional Legal Safeguards You Might Want to Add:</h3>
            <ul>
              <li><strong>"Age restriction" clause:</strong> Users must be 18+ to place an order</li>
              <li><strong>"Force Majeure" clause:</strong> We are not liable for delays due to natural calamities, strikes, pandemics, etc.</li>
              <li><strong>"Indemnity" clause:</strong> Users indemnify the company from liability arising out of misuse of the website or products</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default LegalPrivacyPage;